import styles from "./size-guide.module.css";
const SizeGuide = ({
  sizeguide,
}: {
  sizeguide:
    | {
        chart: {
          [measurement: string]: string;
          size: string;
        }[];
        keys: string[];
      }
    | undefined;
}) => {
  if (!sizeguide) return null;

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <th className={styles.heading}>Size</th>
          {sizeguide?.keys?.map((key: string) => (
            <th key={key} className={styles.heading}>
              {key}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {sizeguide.chart.map((row) => (
          <tr key={row.size} className={styles.row}>
            <td className={styles.size}>{row.size}</td>
            {sizeguide.keys.map((key: string) => (
              <td className={styles.td} key={key}>
                {row[key]}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default function SizeGuideComplete({
  sizeguide,
  isRingProduct,
}: {
  isRingProduct: boolean;
  sizeguide:
    | {
        chart: {
          [measurement: string]: string;
          size: string;
        }[];
        keys: string[];
      }
    | undefined;
}) {
  return (
    <div className={styles["size-guide"]}>
      <SizeGuide sizeguide={sizeguide} />
    </div>
  );
}
